var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize:debounce.50",value:(_vm.updateScrollableState),expression:"updateScrollableState",arg:"debounce",modifiers:{"50":true}}],ref:"appcontainer",staticClass:"pagewrap",class:[
    { 'is-scrollable' : _vm.isScrollable && !_vm.isScrolledToEnd },
    _vm.$route.meta.appClass
  ],attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.showProgress)?_c('Progressbar'):_vm._e(),_c('OverlayBG')],1)}
var staticRenderFns = []

export { render, staticRenderFns }